module.exports = __webpack_public_path__ + "img/hanne.346ca60a.png";